import { formattedAccount as formattedAccountUtil } from '@/utils/tool'

const mixin = {
    methods: {
        showLoading() {
            this.$store.commit('showLoading')
        },
        hideLoading() {
            this.$store.commit('hideLoading')
        },
        toast(str, t = 4, options = {}) {
            const payload = typeof str === 'object' && str !== null ? str : null
            const message = payload ? payload.message : str
            if (!message) return

            const opts = {
                ...(payload || {}),
                ...(typeof t === 'object' ? t : options),
            }
            const duration = typeof t === 'number' ? t : (opts.duration || 4)
            const persistent = opts.persistent === true
            const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`
            const notification = {
                id,
                message,
                actionText: opts.actionText || '',
                action: opts.action,
                persistent,
                dismissible: persistent || !!opts.dismissible,
            }

            this.$store.commit('PUSH_NOTIFICATION', notification)

            if (!persistent) {
                setTimeout(() => {
                    this.$store.commit('REMOVE_NOTIFICATION', id)
                }, Math.max(duration, 1) * 1000)
            }
        },
        // 获取用户当前IP
        getLocation() {
            return fetch('https://ipapi.co/json/')
                .then(response => response.json())
                .then(data => {
                    return data.country_code;
                })
                .catch(error => {
                    console.error('Error fetching location:', error);
                    return ''; // 发生错误，不显示
                });
        },
        // 替换翻译中的东西
        replaceTranslateContent(origin) {
            return origin.replaceAll('[brandName]', this.brandName ? this.brandName : '').
            replaceAll('[phonenumber]', this.tel ? this.tel : '').
            replaceAll('[email]', this.email ? this.email : '').
            replaceAll('[privacyPolicyUrl]', this.privacyPolicyUrl ? this.privacyPolicyUrl : '').
            replaceAll('[termsOfServiceUrl]', this.termsOfServiceUrl ? this.termsOfServiceUrl : '')
        },
        normalizeBooleanFlag(value) {
            if (typeof value === 'boolean') return value
            if (typeof value === 'number') return value === 1
            if (typeof value === 'string') return value === '1' || value.toLowerCase() === 'true'
            return false
        },
        getBillingRuleTaxRate(rule) {
            const taxRate = Number(rule && rule.tax)
            return Number.isFinite(taxRate) && taxRate > 0 ? taxRate : 0
        },
        shouldShowBillingRuleTax(rule) {
            return this.getBillingRuleTaxRate(rule) > 0
        },
        isBillingRulePriceIncludeTax(rule) {
            return this.normalizeBooleanFlag(rule && rule.price_include_tax)
        },
        getBillingRuleDisplayAmount(amount, rule) {
            const numericAmount = Number(amount)
            if (!Number.isFinite(numericAmount)) return numericAmount

            const taxRate = this.getBillingRuleTaxRate(rule)
            if (!taxRate || this.isBillingRulePriceIncludeTax(rule)) {
                return numericAmount
            }

            const taxedAmount = numericAmount * (1 + taxRate / 100)
            return Math.round((taxedAmount + Number.EPSILON) * 100) / 100
        },
        getBillingRuleTaxText(rule) {
            const taxRate = this.getBillingRuleTaxRate(rule)
            if (!taxRate) return ''

            if (this.isBillingRulePriceIncludeTax(rule)) {
                return this.$t('bRule.taxIncluded')
            }

            const normalizedRate = Number.isInteger(taxRate) ? String(taxRate) : String(taxRate)
            return this.$t('bRule.taxIncludedWithRate').replaceAll('[tax]', normalizedRate)
        },
        currencyFormatBillingRule(n, rule, c) {
            return this.currencyFormat(this.getBillingRuleDisplayAmount(n, rule), c)
        },
        formattedAccountBillingRule(amount, rule, currency) {
            const useCurrency = currency || (rule && rule.currency) || this.$store.getters['appConfig/default_currency'] || 'USD'
            return formattedAccountUtil(this.getBillingRuleDisplayAmount(amount, rule), useCurrency)
        },
        formatBillingRuleAmountLabel(amount, rule, currency) {
            const formattedAmount = this.formattedAccountBillingRule(amount, rule, currency)
            const taxText = this.getBillingRuleTaxText(rule)
            return taxText ? `${formattedAmount} (${taxText})` : formattedAmount
        },
        // 货币格式化
        currencyFormat(n, c) {
            if (isNaN(n)) {
                return '--'
            }
            let currency = 'USD'
            if(c) {
                currency = c.toUpperCase()
            } else {
                let rule = this.$store.getters.billing_rule
                if (rule.currency && rule.currency !== '') {
                    currency = rule.currency.toUpperCase()
                }
            }
            let f = new Intl.NumberFormat(this.$i18n.locale, {style: 'currency', currency: currency})
            return f.format(n)
        },
        formattedAccount(amount, currency) {
            let c = currency
            if (!c) {
                c = this.$store.getters['appConfig/default_currency']
            }
            if (!c) {
                const rule = this.$store.getters.billing_rule
                c = rule && rule.currency
            }
            return formattedAccountUtil(amount, c || 'USD')
        },
        formatSubscriptionDetail(discount_type, discount_value, duration_limit, price, price_time, top_limit) {
            const result = []

            const unlimitedText = this.$t('subscriptionType.unlimited') || 'unlimited'
            const valueText = discount_value === -1 ? unlimitedText : discount_value

            const tplKey = discount_value === -1 ? 'unlimitedRentals' : discount_type
            const tpl = this.$t(`subscriptionType.${tplKey}`)

            if (tpl && tpl !== `subscriptionType.${tplKey}`) {
                result.push(tpl.replaceAll('[value]', valueText))
            }

            if (duration_limit && Number(duration_limit) > 0) {
                const baseLimitText = this.$t('subscriptionType.durationLimit')
                let limitText = baseLimitText
                    .replace('[limit]', duration_limit)
                    .replace('[price]', price)
                    .replace('[price_time]', price_time)

                if (top_limit !== undefined) {
                    const maxLimitText = this.$t('subscriptionType.maxLimit')
                    limitText += maxLimitText.replace('[top_limit]', top_limit)
                }

                result.push(limitText)
            }

            return result
        },
        formatSubscriptionTitle(discount_type, discount_value, usage) {
            // discount_type: 9 表示无限次订阅，discount_value: 0
            const isUnlimited = discount_value === -1 || (discount_type === 9 && discount_value === 0)
            const valueText = isUnlimited ? this.$t('subscriptionTitleType.unlimited') : Number(discount_value)

            const tplKey = isUnlimited ? 'unlimitedRentals' : discount_type
            const tpl = this.$t(`subscriptionTitleType.${tplKey}`)

            if (!tpl) return { type: '', usage: '' }

            const typeText = tpl.replace('[value]', valueText)
            const usageTpl = this.$t('subscriptionInfo.usedShort')

            return {
                type: typeText,
                usage: isUnlimited
                    ? ''
                    : usageTpl
                          .replace('[used]', usage || 0)
                          .replace('[total]', discount_value)
            }
        },
        formatSubscriptionInfo(subscription, price, price_time, top_limit) {
            const result = []

            // 1. Period
            const start = new Date(subscription.start_time * 1000)
                .toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })
            const end = new Date(subscription.end_time * 1000)
                .toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })
            result.push(
                this.$t('subscriptionInfo.period')
                    .replace('[start]', start)
                    .replace('[end]', end)
            )

            // 2. Duration Limit
            if (subscription.duration_limit && Number(subscription.duration_limit) > 0) {
                const baseLimitText = this.$t('subscriptionType.durationLimit')
                let limitText = baseLimitText
                    .replace('[limit]', subscription.duration_limit)
                    .replace('[price]', price)
                    .replace('[price_time]', price_time)

                if (top_limit !== undefined) {
                    const maxLimitText = this.$t('subscriptionType.maxLimit')
                    limitText += maxLimitText.replace('[top_limit]', top_limit)
                }

                result.push(limitText)
            }

            // 3. Usage
            if (subscription.discount_value === -1) {
                result.push(this.$t('subscriptionInfo.usageUnlimited'))
            } else {
                const total = subscription.discount_value
                const used = subscription.usage || 0
                const remaining = total - used
                result.push(
                    this.$t('subscriptionInfo.usage')
                        .replace('[total]', total)
                        .replace('[used]', used)
                        .replace('[remaining]', remaining)
                )
            }

            // 4. Auto-renew
            const renewValue = subscription.auto_renew === 1
                ? this.$t('subscriptionInfo.autoRenewTrue')
                : this.$t('subscriptionInfo.autoRenewFalse')
            result.push(
                this.$t('subscriptionInfo.autoRenew').replace('[value]', renewValue)
            )

            return result
        },

        formatBillingRule(rule) {
            switch (this.$i18n.locale) {
                case 'de':
                case 'en':
                case 'es':
                case 'fr':
                case 'it':
                case 'sk':
                case 'zh':
                    return this.formatBillingRule_Common(rule)
                default:
                    return this.formatBillingRule_EN(rule)
            }
        },
        formatBillingRule_EN(rule) {
            if (!rule) {
                return [{ message: "server error" }];
            }
            let rulesArray = [];
            if (parseFloat(rule.price) > 0 && parseInt(rule.price_time) > 0) {
                rulesArray.push({
                    price: this.currencyFormatBillingRule(rule.price, rule, rule.currency) ,
                    priceTime: '/' + rule.price_time + ' minutes' });
            }
            if (parseInt(rule.free_time) > 0 || (parseInt(rule.flat_fee) > 0 && parseInt(rule.flat_fee_time) > 0)) {
                let message = '';

                // 处理 free_time
                if (parseInt(rule.free_time) > 0) {
                    message += 'Free ' + rule.free_time + ' minutes';
                }

                // 处理 flat_fee 和 flat_fee_time
                if (parseFloat(rule.flat_fee) > 0 && parseInt(rule.flat_fee_time) > 0) {
                    if (message) {
                        message += ', ';  // 如果已经有内容，添加逗号分隔
                    }
                    message += this.currencyFormatBillingRule(rule.flat_fee, rule, rule.currency) + ' flat fee for the first ' + rule.flat_fee_time + ' minutes';
                }

                if (message) {
                    rulesArray.push({ message });
                }
            }
            if (parseFloat(rule.low_limit) > 0) {
                rulesArray.push({ li: 'Minimum Fee: ' + this.currencyFormatBillingRule(rule.low_limit, rule, rule.currency) });
            }
            if (parseFloat(rule.top_limit) > 0) {
                rulesArray.push({ li: 'Maximum Daily Fee: ' + this.currencyFormatBillingRule(rule.top_limit, rule, rule.currency) });
            }
            if (parseFloat(rule.pre_auth_amount) > 0) {
                rulesArray.push({ li: this.currencyFormatBillingRule(rule.pre_auth_amount, rule, rule.currency) + ' will be pre-authorized on your payment method' });
            }
            if (parseFloat(rule.deposit) > 0 && parseInt(rule.maximum_rental_time) > 0) {
                rulesArray.push({ li: 'If not returned within ' + rule.maximum_rental_time + ' hours, you will be charged ' + this.currencyFormatBillingRule(rule.deposit, rule, rule.currency) + ', and the power bank will belong to you' });
            }
            if (this.shouldShowBillingRuleTax(rule)) {
                rulesArray.push({ taxHint: this.getBillingRuleTaxText(rule) });
            }
            if (rulesArray.length === 0) {
                return [{ message: "No billing rules" }];
            }
            return rulesArray;
        },

        // 默认
        formatBillingRule_Common(rule) {
            if (!rule) {
                return { message: this.$t('bRule.ruleError') };
            }

            let rulesArray = [];

            if (parseFloat(rule.price) > 0 && parseInt(rule.price_time) > 0) {
                let priceTpl = this.$t('bRule.priceDesc');
                let priceTimeTpl = this.$t('bRule.priceTimeDesc');
                if (priceTpl && priceTimeTpl) {
                    priceTpl = priceTpl.replaceAll('[price]', this.currencyFormatBillingRule(rule.price, rule, rule.currency))
                    priceTimeTpl = priceTimeTpl.replaceAll('[price_time]', rule.price_time)
                    rulesArray.push({ price: priceTpl , priceTime: priceTimeTpl });
                }
            }

            if (parseInt(rule.free_time) > 0 || (parseInt(rule.flat_fee) > 0 && parseInt(rule.flat_fee_time) > 0)) {
                let message = '';

                // 处理 free_time
                if (parseInt(rule.free_time) > 0) {
                    let tpl = this.$t('bRule.freeTimeDesc').replaceAll('[free_time]', rule.free_time);
                    message += tpl;
                }

                // 处理 flat_fee 和 flat_fee_time
                if (parseFloat(rule.flat_fee) > 0 && parseInt(rule.flat_fee_time) > 0) {
                    if (message) {
                        message += ', ';  // 如果已经有内容，添加逗号分隔
                    }
                    let tpl = this.$t('bRule.flatFeeDesc')
                        .replaceAll('[flat_fee_time]', rule.flat_fee_time)
                        .replaceAll('[flat_fee]', this.currencyFormatBillingRule(rule.flat_fee, rule, rule.currency));
                    message += tpl;
                }

                if (message) {
                    rulesArray.push({ message });
                }
            }

            if (parseFloat(rule.low_limit) > 0) {
                let tpl = this.$t('bRule.lowLimitDesc');
                if (tpl) {
                    tpl = tpl.replaceAll('[low_limit]', this.currencyFormatBillingRule(rule.low_limit, rule, rule.currency));
                    rulesArray.push({ li: tpl });
                }
            }

            if (parseFloat(rule.top_limit) > 0) {
                let tpl = this.$t('bRule.topLimitDesc');
                if (tpl) {
                    tpl = tpl.replaceAll('[top_limit]', this.currencyFormatBillingRule(rule.top_limit, rule, rule.currency));
                    rulesArray.push({ li: tpl });
                }
            }

            if (parseFloat(rule.pre_auth_amount) > 0) {
                let tpl = this.$t('bRule.preAuthDesc');
                if (tpl) {
                    tpl = tpl.replaceAll('[pre_auth_amount]', this.currencyFormatBillingRule(rule.pre_auth_amount, rule, rule.currency));
                    rulesArray.push({ li: tpl });
                }
            }

            if (parseFloat(rule.deposit) > 0 && parseInt(rule.maximum_rental_time) > 0) {
                let tpl = this.$t('bRule.depositDesc');
                if (tpl) {
                    tpl = tpl.replaceAll('[maximum_rental_time]', rule.maximum_rental_time).replaceAll('[deposit]', this.currencyFormatBillingRule(rule.deposit, rule, rule.currency))
                    rulesArray.push({ li: tpl });
                }
            }

            if (this.shouldShowBillingRuleTax(rule)) {
                rulesArray.push({ taxHint: this.getBillingRuleTaxText(rule) })
            }

            if (rulesArray.length === 0) {
                rulesArray.push({ message: "No billing rules" });
            }

            return rulesArray;
        }
    }
}
export default mixin
